import { SITE } from "@/config";
import { Reveal } from "@/components/Reveal";
import { PrimaryCTA, GhostCTA } from "@/components/CTA";

const FinalCTA = () => (
  <section data-testid="final-cta-section" className="relative overflow-hidden bg-ink py-32 text-white lg:py-48">
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(212,175,55,0.08),transparent_55%)]" />
    <div className="relative mx-auto max-w-[1440px] px-6 lg:px-12">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-accent">Il primo passo</p>
        <h2 className="mt-8 max-w-5xl font-display text-[clamp(2.2rem,5.5vw,4.6rem)] font-extrabold leading-[1.04] tracking-tighter">
          La tua azienda può crescere senza dipendere completamente da te.
        </h2>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
          Il primo passo è capire cosa oggi sta realmente frenando la sua crescita.
        </p>
      </Reveal>
      <Reveal delay={0.15} className="mt-14">
        <div className="flex flex-wrap items-center gap-4">
          <PrimaryCTA href={SITE.bf360} testid="final-cta" className="px-10 py-5" />
          <GhostCTA to="/contatti" dark testid="final-cta-secondary" className="px-10 py-5">
            Parliamo della tua azienda
          </GhostCTA>
        </div>
        <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
          Fai gratuitamente il Business Freedom 360.
        </p>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
